import React from 'react';
import moment from 'moment';
import { Grid, SvgIcon } from '@material-ui/core';
import classNames from 'classnames';
import { AccessTime, ArrowUpward } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import ChartCard from './ChartCard';

import CustomTable from './CustomTable';
import RegularCard from './RegularCard';
import OrderStats from './OrderStats';
import AlertDialog from './orders/AlertDialog';
import PieGraph from './PieGraph';
import LineGraph from './LIneGraph';
import Loading from './loading';
import { decorateData } from './common/OrderUtil';
import { columnDataSendToday } from './common/constants';
import Orders from './orders/index';

import {
  orderShipmentStats,
  ordersRevenue,
  ordersByStatus,
  getOrders,
  getProducts,
} from '../api/index';
import { abbreviateNumber } from '../assets/numberFormat';

class DashBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      orderStats: null,
      weeklyRevenue: null,
      ordersStatus: null,
    };
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleHeight = this.handleHeight.bind(this);
  }

  componentWillMount() {
    this.setState({
      isFetching: true,
    });
    getProducts().then(products => {
      let index = 0;
      let slicedProducts = [];
      if (products && products.data) {
        slicedProducts = products.data
          .map(product => product)
          .slice(0, 4)
          .map(o => {
            index += 1;
            return [index, o.alternateTitle || o.title, o.soldQuantity, `$${o.soldAmount}`, o.availableQuantity];
          });
      }
      this.setState({
        products: slicedProducts,
      });
    });

    getOrders().then(orders => {
      if (orders && orders.data) {
        const decoratedOrders = decorateData(orders.data);
        const mustShipToday = decoratedOrders
          .map(order => order)
          .slice(0, 4)
          .map(o => [
            o.shipmentRef,
            moment(o.createdAt).format('MM-DD-YY'),
            moment(o.shippingEndsAt).format('MM-DD-YY'),
            o.products[0].productName,
          ]);

        this.setState({
          mustShipToday,
          isFetching: false,
        });
      }
      if (orders && orders.errors) {
        this.setState({ errors: orders.errors });
      }
    });

    this.setState({
      isFetching: true,
    });
    orderShipmentStats().then(stats => {
      if (stats && stats.data) {
        this.setState({
          isFetching: false,
          orderStats: stats.data,
        });
      }
      if (stats && stats.errors) {
        this.setState({ errors: stats.errors });
      }
    });

    this.setState({
      isFetching: true,
    });
    ordersByStatus().then(stats => {
      if (stats && stats.data) {
        stats.data.forEach(item => {
          if (item.status === 'unhandled' || item.status === 'Placed') {
            item.status = 'pending';
          }
        });

        const seriesData = stats.data.map(stat => stat.count);
        const ordersStatus = {
          labels: stats.data.map(orders => orders.status),
          series: [seriesData],
        };

        // const orderStatusTwo = {
        //   labels: stats.data.map(orders => orders.status).slice(4, 8),
        //   series: [stats.data.map(stat => stat.count).slice(4, 8)],
        // };

        this.setState({
          isFetching: false,
          ordersStatus,
        });
      }
      if (stats && stats.errors) {
        this.setState({
          errors: stats.errors,
          isFetching: false,
        });
      }
    });

    this.setState({
      isFetching: true,
    });
    ordersRevenue().then(stats => {
      if (stats && stats.data && stats.data.length > 0) {
        const latestWeekData = stats.data.splice(-7);
        const weeklyRevenue = {
          labels: latestWeekData.map(r => moment(r.date).format('MM-DD')),
          series: latestWeekData.map(r => Number(r.totalAmount)),
        };
        const weeklyOrderCount = latestWeekData.map(r => Number(r.totalCount));
        this.setState({
          weeklyRevenue,
          weeklyOrderCount,
          isFetching: false,
        });
      } else {
        const weeklyRevenue = {
          labels: [],
          series: [],
        };
        const weeklyOrderCount = [];

        this.setState({
          weeklyRevenue,
          weeklyOrderCount,
        });
      }

      if (stats && stats.errors) {
        this.setState({
          errors: stats.errors,
          isFetching: false,
        });
      }
    });
  }

  handleCloseAlert() {
    this.setState({ errors: null });
  }

  handleHeight(height, type) {
    if (type === 'line') {
      this.setState({
        lineHeight: height,
      });
    }
    console.log(height);
    if (type === 'pie') {
      this.setState({
        pieHeight: height,
      });
    }
  }

  render() {
    const parameters =
      this.state.errors && this.state.errors.length > 0
        ? {
            title: 'Errors',
            message: this.state.errors.map(error => error.message),
            okButtonName: 'OK',
            handleClose: this.handleCloseAlert,
          }
        : {};

    return (
      <div className="root">
        {this.state.orderStats ? (
          <Grid className="spark-grid" container>
            <Grid className="spark-grid" lg={2} md={3} sm={6} xs={12}>
              <ChartCard
                chartColor="white"
                title="Monthly Gross Revenue"
                text={
                  <div
                    className={classNames({
                      revenuelow: this.state.orderStats.revenue.monthToDay < 10000,
                      revenuemedium:
                        this.state.orderStats.revenue.monthToDay >= 10000 &&
                        this.state.orderStats.revenue.monthToDay < 100000,
                      revenuehigh: this.state.orderStats.revenue.monthToDay > 100000,
                    })}
                  >
                    {this.state.orderStats.revenue ? (
                      abbreviateNumber(this.state.orderStats.revenue.monthToDay)
                    ) : (
                      <span className="loading">loading...</span>
                    )}
                    <small className="revenue-currency">
                      {this.state.orderStats.revenue.monthToDay ? ' NZD' : null}{' '}
                    </small>
                  </div>
                }
                statIcon={AccessTime}
                statText="updated 4 minutes ago"
                type="spark"
              />
            </Grid>
            <Grid className="spark-grid" lg={2} md={3} sm={6} xs={12}>
              <ChartCard
                chartColor="white"
                title="Weekly Gross Revenue"
                text={
                  <div
                    className={classNames({
                      revenuelow: this.state.orderStats.revenue.lastSevenDays < 10000,
                      revenuemedium:
                        this.state.orderStats.revenue.lastSevenDays >= 10000 &&
                        this.state.orderStats.revenue.lastSevenDays < 100000,
                      revenuehigh: this.state.orderStats.revenue.lastSevenDays > 100000,
                    })}
                  >
                    {this.state.orderStats.revenue ? (
                      abbreviateNumber(this.state.orderStats.revenue.lastSevenDays)
                    ) : (
                      <span className="loading">loading...</span>
                    )}
                    <small className="revenue-currency">
                      {this.state.orderStats.revenue.lastSevenDays ? ' NZD' : null}{' '}
                    </small>
                  </div>
                }
                statIcon={AccessTime}
                statText="updated 4 minutes ago"
                type="spark"
              />
            </Grid>
            <Grid className="spark-grid" lg={2} md={3} sm={6} xs={12}>
              <ChartCard
                chartColor="white"
                title="Daily Gross Revenue"
                text={
                  <div
                    className={classNames({
                      revenuelow: this.state.orderStats.revenue.today < 10000,
                      revenuemedium:
                        this.state.orderStats.revenue.today >= 10000 &&
                        this.state.orderStats.revenue.today < 100000,
                      revenuehigh: this.state.orderStats.revenue.today > 100000,
                    })}
                  >
                    {this.state.orderStats.revenue ? (
                      abbreviateNumber(this.state.orderStats.revenue.today)
                    ) : (
                      <span className="loading">loading...</span>
                    )}
                    <small className="revenue-currency">
                      {this.state.orderStats.revenue.today ? ' NZD' : null}{' '}
                    </small>
                  </div>
                }
                statIcon={AccessTime}
                statText="updated 4 minutes ago"
                type="spark"
              />
            </Grid>
            <Grid className="spark-grid" lg={2} md={3} sm={6} xs={12}>
              <Link
                style={{ textDecoration: 'none', color: 'white' }}
                to="/orders/?shippingTime=today,coming"
              >
                {' '}
                <ChartCard
                  chartColor="white"
                  title="Orders to be Sent"
                  text={
                    <div className="revenuehigh">{this.state.orderStats.comingOrdersCount + this.state.orderStats.todayOrdersCount}</div>
                  }
                  statIcon={ArrowUpward}
                  statText="Up +20%"
                  type="spark"
                />
              </Link>
            </Grid>
            <Grid className="spark-grid" lg={2} md={3} sm={6} xs={12}>
              <Link
                style={{ textDecoration: 'none', color: 'white' }}
                to="/orders/?shippingTime=today"
              >
                <ChartCard
                  chartColor="white"
                  title="Orders to be Sent today"
                  text={
                    <div className="revenuemedium">{this.state.orderStats.todayOrdersCount}</div>
                  }
                  statIcon={AccessTime}
                  statText="updated 4 minutes ago"
                  type="spark"
                />
              </Link>
            </Grid>
            <Grid className="spark-grid" lg={2} md={3} sm={6} xs={12}>
              <Link
                style={{ textDecoration: 'none', color: 'white' }}
                to="/orders/?shippingTime=late"
              >
                <ChartCard
                  chartColor="white"
                  title="Overdue Orders"
                  text={<div className="revenuelow">{this.state.orderStats.lateOrdersCount} </div>}
                  statIcon={AccessTime}
                  statText="updated 4 minutes ago"
                  type="spark"
                />
              </Link>
            </Grid>
          </Grid>
        ) : null}
        <Grid className="spark-grid" container>
          <Grid className="spark-grid" item xs={12} sm={12} md={6}>
            {this.state.weeklyRevenue ? (
              <LineGraph
                title="Weekly Order Performance"
                icon={AccessTime}
                textData=""
                seriesData={this.state.weeklyRevenue.series}
                graphLabels={this.state.weeklyRevenue.labels}
                weeklyOrderCount={this.state.weeklyOrderCount}
                statText="Updated 10 Minutes Ago"
                axisInt={100000}
              />
            ) : null}
          </Grid>
          <Grid className="spark-grid" item xs={12} sm={12} md={6}>
            {this.state.mustShipToday ? (
              <RegularCard
                headerColor="white"
                cardTitle="Orders to be Sent today"
                cardSubtitle="Please send these orders ASAP"
                type="orders"
                content={
                  <Orders
                    withOutToolBar
                    withOutPagination
                    columnData={columnDataSendToday}
                    pageInfo={{
                      pageSize: 4,
                      page: 0,
                    }}
                  />
                }
              />
            ) : null}
          </Grid>
          {/* <Grid item xs={12} sm={12} md={4}>
            / this.state.ordersStatus ?
            //   <DoughnutGraph
            //     title={'Orders by status'}
            //     icon={AccessTime}
            //     textData={''}
            //     seriesData={this.state.orderStatusTwo.series}
            //     labels={this.state.orderStatusTwo.labels}
            //     statText={'Updated 20 minutes ago'}
            //   />
            // ) : null}
          </Grid> */}
          <Grid className="spark-grid" item xs={12} sm={12} md={4}>
            {this.state.ordersStatus ? (
              <PieGraph
                title="Orders by status"
                icon={AccessTime}
                textData=""
                seriesData={this.state.ordersStatus.series}
                labels={this.state.ordersStatus.labels}
                statText="Updated 20 minutes ago"
              />
            ) : null}
          </Grid>
          <Grid className="spark-grid" item xs={12} sm={12} md={4}>
            {this.state.products ? (
              <RegularCard
                headerColor="white"
                cardTitle="Top Selling Products"
                cardSubtitle="Your top selling products of all time"
                type="products"
                content={
                  <CustomTable
                    tableHeaderColor="white"
                    tableHead={['ID', 'Name', 'Sold Qty', 'Sold Amount', 'Avaliable Qty']}
                    tableData={this.state.products}
                  />
                }
              />
            ) : null}
          </Grid>
          <Grid className="spark-grid" item xs={12} sm={12} md={4}>
            <RegularCard
              headerColor="white"
              cardTitle="Order Statistics"
              cardSubtitle="Your current stats"
              content={
                this.state.orderStats ? (
                  <OrderStats
                    ordersCount={this.state.orderStats.totalOrdersCount}
                    hoursToShip={this.state.orderStats.averageTimeToShip}
                    averageOrderAmount={this.state.orderStats.averageOrderAmount}
                    shippedOnTime={this.state.orderStats.shippedOnTimePercentage}
                  />
                ) : null
              }
            />
          </Grid>
        </Grid>

        <div>
          <Loading show={this.state.isFetching} text="Loading..." />
        </div>
        {this.state.errors &&
          this.state.errors.length > 0 && <AlertDialog parameters={parameters} />}
      </div>
    );
  }
}

export default DashBoard;



// WEBPACK FOOTER //
// ./src/components/DashBoard.jsx